import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { CalendarMinimalisticIcon, HandShakeIcon, Header } from "@/shared/ui";

export const PurposeHeader = () => {
  const navigate = useNavigate();

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: ROUTES.CONSULTATIONS.OVERVIEW,
              icon: CalendarMinimalisticIcon,
              label: t`Consultations`,
            },
            {
              href: ROUTES.CONSULTATIONS.PURPOSE,
              icon: HandShakeIcon,
              label: t`Consultation Purpose`,
            },
          ]}
        />

        <div className="flex items-center gap-2">
          <Header.GoBackButton
            onClick={() => navigate(ROUTES.CONSULTATIONS.OVERVIEW)}
            className="md:hidden"
          />
          <Header.Title>{t`What's the purpose of your consultation?`}</Header.Title>
        </div>

        <Header.Description>
          {t`Please choose the option that best matches your reason for reaching out today to help us provide the best support possible.`}
        </Header.Description>
      </Header.Content>
    </Header.Root>
  );
};
